const media = (name, title) => ({
  src: `/einsatz/faps/${name}.png`,
  title,
  alt: title,
  inlineTitle: null,
  inlineLabel: null,
});

export const FAPS_CONTENT = {
  title: 'Prusiksystem (FAPS)',
  subtitle: 'Prusiksystem (Fast Anchor Prusik System)',
  source: 'Stand: 01.12.2025',
  referenceDocument: {
    label: 'Original-PDF herunterladen',
    href: '/einsatz/faps/prusiksystem-faps.pdf',
    filename: '2025_12_01 Prusiksystem_FAPS.pdf',
  },
  sections: [
    {
      id: 'faps-erlaeuterung',
      title: 'Erläuterung',
      blocks: [
        {
          paragraphs: [
            'Das Erstellen von Festpunkten und die Planung der Seilverläufe stellt mit den anspruchsvollsten Teil des Höhenrettereinsatzes dar. Um in diesem Bereich der Anwenderin / dem Anwender eine zusätzliche Möglichkeit zur schnelle Festpunkterstellung sowie dem Erstellen von kurzen Abseilstrecken zu bieten, wird ein Prusiksystem mit einem Kurzseil zur Verfügung gestellt.',
          ],
        },
        {
          groups: [
            {
              title: 'Durch die Einführung ergeben sich im Bereich der Festpunkte folgende Vorteile:',
              items: [
                'schnell einstellbar',
                'universell',
                'überwiegendes Arbeiten über Zentralen Festpunkt -> Umstellen auf 2 einzelne Festpunkte möglich',
              ],
            },
            {
              title: 'Eine anderweitige Nutzung jederzeit möglich und gewünscht:',
              items: ['eigene Absturzsicherung', 'schnelle Erreichbarkeit eines Patienten'],
            },
          ],
        },
      ],
    },
    {
      id: 'faps-bestandteile',
      title: 'Bestandteile',
      blocks: [
        {
          paragraphs: [
            'Für jeden Höhenretter wird ergänzend zum Service Pack eine kleine Seiltasche mit einem 20m Halbstatikseil auf dem Alarmfahrzeug sowie im Übungsmaterial zur Verfügung gestellt.',
          ],
        },
        {
          groups: [
            {
              title: 'Die Sets bestehen aus:',
              items: [
                '20m Halbstatikseil mit aufgelegter Prusikschlinge inkl. Karabiner',
                'Seilanfang mit Achterknoten & Karabiner',
                'Seilende mit Seilendknoten',
                'Karabiner an Seiltasche zum Anhängen an den Gurt',
              ],
            },
            {
              title: 'Prusikschlinge:',
              items: ['1m lang', '8mm (rot) oder 10mm (gelb) Durchmesser', 'Mit 3 Wicklungen aufgelegt'],
            },
          ],
        },
        {
          mediaGallery: [
            media('seilset', 'FAPS – Halbstatikseil mit Prusikschlinge und Karabinern'),
            media('seiltasche', 'FAPS – Seiltasche'),
          ],
        },
      ],
    },
    {
      id: 'faps-zentraler-festpunkt',
      title: '1. Zentraler Festpunkt',
      blocks: [
        {
          heading: 'Anwendungsmöglichkeiten',
          paragraphs: [
            'Die nachfolgenden Anwendungsmöglichkeiten wurden im Rahmen der Pflichtfortbildung 2025 geschult, schließen aber andere (regelkonforme) Anwendungen nicht aus.',
          ],
        },
        {
          description: 'Erstellen eines zentralen Festpunktes aus zwei einzelnen Festpunkten',
          media: media('zentraler-festpunkt', 'FAPS – zentraler Festpunkt aus zwei einzelnen Festpunkten'),
        },
      ],
    },
    {
      id: 'faps-spinnenverankerung',
      title: '2. Spinnenverankerung',
      description: 'Erstellung einer Spinnenverankerung mit und ohne zusätzlicher Sicherungsmöglichkeit an der Kante',
      media: media('spinnenverankerung', 'FAPS – Spinnenverankerung mit und ohne zusätzliche Sicherungsmöglichkeit'),
    },
    {
      id: 'faps-blockverbau',
      title: '3. Blockverbau',
      description: 'Erstellung eines Blockverbaus mit und ohne zusätzlicher Sicherungsmöglichkeit an der Kante',
      media: media('blockverbau', 'FAPS – Blockverbau mit und ohne zusätzliche Sicherungsmöglichkeit'),
    },
    {
      id: 'faps-span-anchor',
      title: '4. Span Anchor („Wäscheleine“)',
      description: 'Erstellung eines Span Anchor (umgangssprachlich „Wäscheleine“) mit und ohne Sicherung gegen Verrutschen',
      media: media('span-anchor', 'FAPS – Span Anchor mit und ohne Sicherung gegen Verrutschen'),
    },
    {
      id: 'faps-sicherheit',
      title: 'Anmerkungen und Sicherheitshinweise',
      blocks: [
        {
          paragraphs: [
            'Die klassischen Festpunktkonstruktionen entsprechend des Begleitheftes Höhenrettung in der jeweils aktuellen Fassung müssen weiterhin beherrscht werden. Insbesondere Konstruktionen, die mehr als 2x 20m-Seillänge erfordern sowie Festpunktverlagerungen über 20m hinaus können mit dem System nicht schnell und zielführend erstellt werden.',
            'Nach der Nutzung sind sowohl das Seil als auch die Prusikschlinge auf den ordnungsgemäßen Zustand zu prüfen.',
            { text: 'Die Prusik muss zwingend sauber gelegt und fest gezogen werden.', strong: true },
            'Bei hohen Lasten ist so lang wie möglich mit 2 gleichmäßig belasteten Abseilgeräten zu arbeiten, um einen hohen Kraftspitze beim Verlust einer Abseilstrecke zu vermeiden.',
            'Bei 6kN und 3 Wicklungen der Prusik kam es zu einem Verrutschen der Prusik mit Verglasung des Seilmantels. Mit 4 Wicklungen hielt die Prusik bis 8kN fest auf dem Seil. Es kam zu keinem Verrutschen. Bei der Anwendung der o.g. Festpunktkonstruktionen werden drei Wicklungen als ausreichend betrachtet.',
            { text: 'Die Technik ASAP am Festpunkt sollte nicht angewendet werden.', strong: true, color: 'error.main' },
            'gez.\nLeitung der Höhenrettung',
          ],
        },
      ],
    },
  ],
};
